import React from "react";
import PropTypes from "prop-types";
import { Heading, HeadingSize } from "@sunwing/wvi-components";
import * as styles from "./GuestReview.module.scss";

const GuestReview = ({ data, translations }) => {
	return (
		<div className={styles?.ratings}>
			{translations.guestReview && (
				<Heading className={styles?.ratings__subtitle} Tag="div" size={HeadingSize.eyebrow}>
					{translations.guestReview}
				</Heading>
			)}
			<Heading className={styles?.ratings__reviews} Tag="h3" size={HeadingSize.md}>
				{data.overallRating} {data.overallRatingDescription}
			</Heading>
			<Heading className={styles?.ratings__sampleSize} Tag="div" size={HeadingSize.micro}>
				{translations.basedOnNum?.replace("{{numReviews}}", data.numberOfReviews)}
			</Heading>

			<div className={styles?.ratings__facilities}>
				{!!data.beachRating && (
					<div className={styles?.entry}>
						<span className={styles?.entry__label}>{translations.beach}</span>
						<div className={styles?.entry__rating}>
							<span>{data.beachRating.toFixed(1)}</span>
						</div>
					</div>
				)}

				{!!data.roomRating && (
					<div className={styles?.entry}>
						<span className={styles?.entry__label}>{translations.room}</span>
						<div className={styles?.entry__rating}>
							<span>{data.roomRating.toFixed(1)}</span>
						</div>
					</div>
				)}

				{!!data.entertainmentRating && (
					<div className={styles?.entry}>
						<span className={styles?.entry__label}>{translations.entertainment}</span>
						<div className={styles?.entry__rating}>
							<span>{data.entertainmentRating.toFixed(1)}</span>
						</div>
					</div>
				)}

				{!!data.diningRating && (
					<div className={styles?.entry}>
						<span className={styles?.entry__label}>{translations.dining}</span>
						<div className={styles?.entry__rating}>
							<span>{data.diningRating.toFixed(1)}</span>
						</div>
					</div>
				)}

				{!!data.poolRating && (
					<div className={styles?.entry}>
						<span className={styles?.entry__label}>{translations.pool}</span>
						<div className={styles?.entry__rating}>
							<span>{data.poolRating.toFixed(1)}</span>
						</div>
					</div>
				)}

				{!!data.serviceRating && (
					<div className={styles?.entry}>
						<span className={styles?.entry__label}>{translations.service}</span>
						<div className={styles?.entry__rating}>
							<span>{data.serviceRating.toFixed(1)}</span>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

GuestReview.propTypes = {
	data: PropTypes.object,
	translations: PropTypes.object,
};

export default GuestReview;
export { GuestReview };
